import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Input } from '@/components/ui/input';
import { Search as SearchIcon, X } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';
interface StoriesFilterProps {
  categories: string[];
  activeFilter: string;
  onFilterChange: (filter: string) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
}
const StoriesFilter: React.FC<StoriesFilterProps> = ({
  categories,
  activeFilter,
  onFilterChange,
  searchQuery,
  onSearchChange
}) => {
  const {
    resolvedTheme
  } = useTheme();
  const isDark = resolvedTheme === 'dark';
  const [inputFocused, setInputFocused] = useState(false);

  // Ensure all our categories are included
  const allCategories = ['all', ...categories];
  const handleClearSearch = () => {
    onSearchChange('');
  };
  return <div className="sticky top-20 z-20 bg-inherit w-full py-0">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-12 gap-6">
        <div className="w-full md:w-auto">
          <ScrollArea className="w-full pb-4" orientation="horizontal">
            <div className="flex items-center space-x-3 px-1 min-w-max">
              {allCategories.map(category => <Button key={category} variant={activeFilter === category ? "secondary" : "outline"} size="sm" onClick={() => onFilterChange(category)} className={cn("whitespace-nowrap rounded-full border hover:bg-muted transition-colors", activeFilter === category ? "bg-secondary text-secondary-foreground font-medium" : "bg-transparent hover:text-foreground")}>
                  {category.charAt(0).toUpperCase() + category.slice(1)}
                </Button>)}
            </div>
          </ScrollArea>
        </div>
        <div className="w-full md:w-auto">
          <div className={cn("relative rounded-full transition-all duration-300", inputFocused ? isDark ? "bg-zinc-800" : "bg-white border-zinc-300" : isDark ? "bg-zinc-900" : "bg-zinc-100", inputFocused && "ring-1 ring-zinc-400")}>
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
              
            </div>
            
            {searchQuery && <button onClick={handleClearSearch} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600">
                <X size={16} />
              </button>}
          </div>
        </div>
      </div>
    </div>;
};
export default StoriesFilter;